import {
    RESET_DOCTOR_ACTION_STATE,
    RESET_DOCTOR_STATE,
    GET_DOCTOR_LISTING,
    GET_DOCTOR_LISTING_SUCCESS,
    GET_DOCTOR_LISTING_FAIL,
    GET_DOCTOR_DETAILS,
    GET_DOCTOR_DETAILS_SUCCESS,
    GET_DOCTOR_DETAILS_FAIL,
    UPDATE_DOCTOR,
    UPDATE_DOCTOR_SUCCESS,
    UPDATE_DOCTOR_FAIL,
    DOCTOR_ACTIVATION,
    DOCTOR_ACTIVATION_SUCCESS,
    DOCTOR_ACTIVATION_FAIL,
    GET_DOCTOR_HISTORY_LISTING,
    GET_DOCTOR_HISTORY_LISTING_SUCCESS,
    GET_DOCTOR_HISTORY_LISTING_FAIL,
    EXPORT_DOCTOR_LISTING,
    EXPORT_DOCTOR_LISTING_SUCCESS,
    EXPORT_DOCTOR_LISTING_FAIL,
    GET_DOCTOR_ORDERS,
    GET_DOCTOR_ORDERS_SUCCESS,
    GET_DOCTOR_ORDERS_FAIL,
    GET_DOCTOR_COMMISSION,
    GET_DOCTOR_COMMISSION_SUCCESS,
    GET_DOCTOR_COMMISSION_FAIL,
    GET_DOCTOR_COMMISSION_BREAKDOWN,
    GET_DOCTOR_COMMISSION_BREAKDOWN_SUCCESS,
    GET_DOCTOR_COMMISSION_BREAKDOWN_FAIL,
    ADD_DOCTOR,
    ADD_DOCTOR_SUCCESS,
    ADD_DOCTOR_FAIL,
    DELETE_DOCTOR,
    DELETE_DOCTOR_SUCCESS,
    DELETE_DOCTOR_FAIL,
} from "./actionTypes";

export const getDoctorListing = (data) => ({
    type: GET_DOCTOR_LISTING,
    payload: data,
});

export const getDoctorListingSuccess = data => ({
    type: GET_DOCTOR_LISTING_SUCCESS,
    payload: data,
});

export const getDoctorListingFail = error => ({
    type: GET_DOCTOR_LISTING_FAIL,
    payload: error,
});

export const getDoctorDetails = (data) => ({
    type: GET_DOCTOR_DETAILS,
    payload: data,
});

export const getDoctorDetailsSuccess = (data) => ({
    type: GET_DOCTOR_DETAILS_SUCCESS,
    payload: data,
});

export const getDoctorDetailsFail = (error) => ({
    type: GET_DOCTOR_DETAILS_FAIL,
    payload: error,
});

export const addDoctor = (data) => ({
    type: ADD_DOCTOR,
    payload: data,
});

export const addDoctorSuccess = (data) => ({
    type: ADD_DOCTOR_SUCCESS,
    payload: data,
});

export const addDoctorFail = (error) => ({
    type: ADD_DOCTOR_FAIL,
    payload: error,
});

export const updateDoctor = (data) => ({
    type: UPDATE_DOCTOR,
    payload: data,
});

export const updateDoctorSuccess = (data) => ({
    type: UPDATE_DOCTOR_SUCCESS,
    payload: data,
});

export const updateDoctorFail = (error) => ({
    type: UPDATE_DOCTOR_FAIL,
    payload: error,
});

export const deleteDoctor = (data) => ({
    type: DELETE_DOCTOR,
    payload: data,
});

export const deleteDoctorSuccess = (data) => ({
    type: DELETE_DOCTOR_SUCCESS,
    payload: data,
});

export const deleteDoctorFail = (error) => ({
    type: DELETE_DOCTOR_FAIL,
    payload: error,
});

export const doctorActivation = (data) => ({
    type: DOCTOR_ACTIVATION,
    payload: data,
});

export const doctorActivationSuccess = (data) => ({
    type: DOCTOR_ACTIVATION_SUCCESS,
    payload: data,
});

export const doctorActivationFail = (error) => ({
    type: DOCTOR_ACTIVATION_FAIL,
    payload: error,
});

export const getDoctorHistoryListing = (data) => ({
    type: GET_DOCTOR_HISTORY_LISTING,
    payload: data,
});

export const getDoctorHistoryListingSuccess = (data) => ({
    type: GET_DOCTOR_HISTORY_LISTING_SUCCESS,
    payload: data,
});

export const getDoctorHistoryListingFail = (error) => ({
    type: GET_DOCTOR_HISTORY_LISTING_FAIL,
    payload: error,
});

export const exportDoctorListing = (data) => ({
    type: EXPORT_DOCTOR_LISTING,
    payload: data,
});

export const exportDoctorListingSuccess = (data) => ({
    type: EXPORT_DOCTOR_LISTING_SUCCESS,
    payload: data,
});

export const exportDoctorListingFail = (error) => ({
    type: EXPORT_DOCTOR_LISTING_FAIL,
    payload: error,
});

export const getDoctorOrders = (data) => ({
    type: GET_DOCTOR_ORDERS,
    payload: data,
});

export const getDoctorOrdersSuccess = (data) => ({
    type: GET_DOCTOR_ORDERS_SUCCESS,
    payload: data,
});

export const getDoctorOrdersFail = (error) => ({
    type: GET_DOCTOR_ORDERS_FAIL,
    payload: error,
});

export const getDoctorCommission = (data) => ({
    type: GET_DOCTOR_COMMISSION,
    payload: data,
});

export const getDoctorCommissionSuccess = (data) => ({
    type: GET_DOCTOR_COMMISSION_SUCCESS,
    payload: data,
});

export const getDoctorCommissionFail = (error) => ({
    type: GET_DOCTOR_COMMISSION_FAIL,
    payload: error,
});

export const getDoctorCommissionBreakdown = (data) => ({
    type: GET_DOCTOR_COMMISSION_BREAKDOWN,
    payload: data,
});

export const getDoctorCommissionBreakdownSuccess = (data) => ({
    type: GET_DOCTOR_COMMISSION_BREAKDOWN_SUCCESS,
    payload: data,
});

export const getDoctorCommissionBreakdownFail = (error) => ({
    type: GET_DOCTOR_COMMISSION_BREAKDOWN_FAIL,
    payload: error,
});

//reset
export const resetDoctorActionState = () => {
    return {
        type: RESET_DOCTOR_ACTION_STATE,
    }
}
export const resetDoctorState = () => {
    return {
        type: RESET_DOCTOR_STATE,
    }
}

